import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import DrawerComponent from 'atoms/drawer';
import getRoutes from 'config/routes';
import useWindowDimensions from 'hooks/useWindowDimensions';
import AdminNavbar from 'organisms/AdminNavbar';
import AppointmentActionsModal from 'organisms/Appointments/AppointmentActions/AppointmentActionsModal';
import AppointmentCompletedModal from 'organisms/DrawerContent/Payment/AppointmentCompletedModal';
import { MobileNavbar } from 'organisms/MobileNavbar';
import Navbar from 'organisms/Navbar';
import ScrollToTop from 'organisms/ScrollToTop';

dayjs.extend(utc);

function AppContainer() {
  const { isAdmin } = useSelector((state) => state.user);
  const { appointmentActionsModal, checkoutSuccessModal } = useSelector(
    (state) => state.ui
  );
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  return (
    <>
      <ScrollToTop />
      <div id="app">
        <div className="app-wrapper">
          <div className="app-wrapper-container">
            <Toaster
              toastOptions={{
                className: 'toast',
                duration: 4000,
                position: 'bottom-center',
              }}
            />
            <DrawerComponent />
            <Navbar isAdmin={isAdmin} />
            {appointmentActionsModal.isOpen && <AppointmentActionsModal />}
            {checkoutSuccessModal.isOpen && <AppointmentCompletedModal />}
            {isMobile && <MobileNavbar variant="absolute" color="grey" />}
            <div className="w-100 flex-column">
              {!isMobile && <AdminNavbar />}
              {getRoutes()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppContainer;
